import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { EyeSvg } from './svgs';

export const IconEye: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={EyeSvg} viewBox="0 0 24 24" {...props} />;
};
